















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Location } from "vue-router";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import BaseAvatar from "@/components/BaseAvatar";

@Component({ name: "AvatarDescription", components: { BaseAvatar } })
export default class AvatarDescription extends Vue {
  @Prop({ required: true })
  public readonly userPublicData!: UserPublicData;

  @Prop({ type: Number, default: 56 })
  public readonly avatarSize!: number;

  @Prop({ type: String })
  public readonly title!: string;

  @Prop({ type: String })
  public readonly description!: string;

  @Prop()
  public readonly to!: Location;

  @Prop({ type: Boolean, default: false })
  public readonly borderBottom!: boolean;
}
